<template>
  <div class="user-edit" >
    <md-card>
      <md-card-header>
        <div class="md-title" v-if="user._id">{{ user.firstname + " " + user.lastname }}</div>
        <translate tag="div" class="md-title" v-else>Add New User</translate>
        <translate tag="div" class="md-caption">Set basic information here</translate>
      </md-card-header>

      <md-card-content>
        <form novalidate @submit.stop.prevent="submit">

          <md-layout md-gutter="16">
            <md-layout md-flex="50">
              <md-input-container :class="{'md-input-invalid': !validFirstname(user.firstname) && firstnameDirty }">
                <md-icon>account_box</md-icon>
                <translate tag="label">Firstname</translate>
                <md-input id="user-firstname" @input.native="firstnameDirty = true" type="text" v-model="user.firstname"  :value="user.firstname" required></md-input>
                <span class="md-error"><translate>Firstname must be filled</translate></span>
              </md-input-container>
            </md-layout>
            <md-layout>
              <md-input-container :class="{'md-input-invalid': !validLastname(user.lastname) && lastnameDirty }">
                <md-icon>account_box</md-icon>
                <translate tag="label">Lastname</translate>
                <md-input id="user-lastname" @input.native="lastnameDirty = true" type="text" v-model="user.lastname"  :value="user.lastname" required></md-input>
                <span class="md-error"><translate>Lastname must be filled</translate></span>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout md-gutter="16">
            <md-layout>
              <md-input-container :class="{'md-input-invalid': !validEmail(user.email) && emailDirty }">
                <md-icon>email</md-icon>
                <translate tag="label">E-mail</translate>
                <md-input id="user-email" @input.native="emailDirty = true" type="email" v-model="user.email" :value="user.email" required></md-input>
                <span class="md-error"><translate>Invalid e-mail</translate></span>
              </md-input-container>
            </md-layout>
            <md-layout class="active-checkbox">
              <md-checkbox id="active" v-model="user.active" class="md-primary"><translate>Active</translate></md-checkbox>
            </md-layout>
          </md-layout>

          <md-layout class="heading-section">
            <span class="md-subheading"><translate>Depot:</translate></span>
          </md-layout>

          <md-layout md-gutter="16">
            <md-layout md-flex="50">
              <md-input-container>
                <md-icon>business</md-icon>
                <translate tag="label">Depot</translate>
                <md-select name="customers" id="customers" multiple v-model="user.customers">
                  <md-option v-for="customer in allCustomers" :value="customer.name" :key="customer._id">{{customer.name}}</md-option>
                </md-select>
              </md-input-container>
            </md-layout>
            <md-layout>
              <div>
                <translate tag="div" class="orig-customer">Depot stated at registration: %{ user.customerOrig }</translate>
              </div>
            </md-layout>
          </md-layout>
          <md-layout md-gutter="16">
            <md-layout md-flex="50">
              <md-input-container>
                <md-icon>phone</md-icon>
                <translate tag="label">Work Phone</translate>
                <md-input id="user-workphone" type="text" v-model="user.workphone" :value="user.workphone" ></md-input>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout class="heading-section">
            <translate align="left" class="md-subheading">Private Contact:</translate>
          </md-layout>

          <md-layout md-gutter="16">
            <md-layout>
              <md-input-container>
                <md-icon>contact_mail</md-icon>
                <translate tag="label">Private E-mail</translate>
                <md-input id="user-private-email" type="text" v-model="user.private.email" :value="user.private.email" ></md-input>
              </md-input-container>
            </md-layout>
            <md-layout>
              <md-input-container>
                <md-icon>phone</md-icon>
                <translate tag="label">Phone</translate>
                <md-input id="user-private-phone" type="text" v-model="user.private.phone" :value="user.private.phone" ></md-input>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout class="heading-section">
            <translate align="left" class="md-subheading">Private Address:</translate>
          </md-layout>

          <md-layout>
            <md-input-container>
              <md-icon>home</md-icon>
              <translate tag="label">Street</translate>
              <md-input id="user-address-street" type="text" v-model="user.address.street" :value="user.address.street" ></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-gutter="16">
            <md-layout>
              <md-input-container>
                <md-icon>markunread_mailbox</md-icon>
                <translate tag="label">Postal Code</translate>
                <md-input id="user-address-postcode" type="text" v-model="user.address.postcode" :value="user.address.postcode" ></md-input>
              </md-input-container>
            </md-layout>
            <md-layout>
              <md-input-container>
                <md-icon>location_city</md-icon>
                <translate tag="label">City</translate>
                <md-input id="user-address-city" type="text" v-model="user.address.city" :value="user.address.city" ></md-input>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout>
            <translate align="left" class="md-subheading">Payment Method:</translate>
            <md-input-container class="input-no-top-margin">
              <md-icon>payment</md-icon>
              <md-select v-model="user.payment">
                <md-option value="0" >{{ trMonthly }}</md-option>
                <md-option value="1" >{{ trOnDelivery }}</md-option>
              </md-select>
            </md-input-container>
          </md-layout>

          <md-layout>
            <md-checkbox id="admin" v-model="user.admin" class="md-primary"><translate>Administrator rights</translate></md-checkbox>
          </md-layout>
          <md-layout>
            <translate v-if="user._id">Registered on: %{ registeredOn }</translate>
          </md-layout>

        </form>
      </md-card-content>
      <md-card-actions>
        <md-button @click.native="cancelForm()"><translate>Cancel</translate></md-button>
        <md-button id="submit-user" class="md-raised md-primary" @click.native="submit()"><translate>Save</translate></md-button>
      </md-card-actions>

      <md-snackbar md-position="bottom center" ref="snackbar" :md-duration="4000">
        <translate>The specified e-mail is already registered</translate>
        <md-button @click.native="$refs.snackbar.close()"><translate>Close</translate></md-button>
      </md-snackbar>
    </md-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import validator from 'validator'
import moment from 'moment' // eslint-disable-line no-unused-vars

export default {
  name: 'user-form',
  data () {
    return {
      firstnameDirty: false,
      lastnameDirty: false,
      emailDirty: false,
      registeredOn: ''
    }
  },
  props: [ 'user' ],
  async created () {
    if (this.user._id !== undefined) { // fetch the latest version of user from the server
      await this.$store.dispatch('fetchOneUser', this.user._id)
    } else {
      this.user.payment = '0'
    }
    this.registeredOn = moment(this.user.registeredOn).locale(Vue.config.language).format('L')
  },
  watch: {
    language (lang) {
      this.onChangeLang(this.user.payment)
    }
  },
  computed: {
    ...mapGetters([
      'allCustomers',
      'allUsers'
    ]),
    trMonthly () {
      return this.$gettext('Monthly')
    },
    trOnDelivery () {
      return this.$gettext('On Delivery')
    },
    language () {
      return this.$language.current
    }
  },
  methods: {
    onChangeLang (value) {
      // force fields to change ...
      this.user.payment = ''

      Vue.nextTick(() => {
        // ... and change them back to original values
        this.user.payment = value
      })
    },
    ...mapMutations([
      'userCancelEdit'
    ]),
    ...mapActions([
      'saveUser'
    ]),
    emailRegistered (email) { // no checking on the server...
      return this.allUsers.some((user) => {
        return user.email === email && user._id !== this.user._id
      })
    },
    async submit () {
      this.firstnameDirty = true
      this.lastnameDirty = true
      this.emailDirty = true
      if (this.validFirstname(this.user.firstname) && this.validLastname(this.user.lastname) && this.validEmail(this.user.email)) {
        if (this.emailRegistered(this.user.email)) {
          this.$refs.snackbar.open()
        } else {
          await this.saveUser(Vue.config.language)
          this.$router.push({ name: 'tab-1' })
        }
      }
    },
    cancelForm () {
      this.$router.push({ name: 'tab-1' })
      this.userCancelEdit()
    },
    validFirstname (firstname) {
      return firstname !== ''
    },
    validLastname (lastname) {
      return lastname !== ''
    },
    validEmail (email) {
      return validator.isEmail(email)
    }
  }
}
</script>

<style scoped>
.user-edit {
  max-width: 1000px;
  margin: auto;
}
.heading-section {
  margin-top: 10px;
  margin-bottom: 10px;
}
.md-input-container label {
  color: rgba(0, 0, 0, .45);
}
.orig-customer {
  margin-top: 20px;
  font-size: 16px;
  line-height: 33px;
  margin-left: 10px;
  color: gray;
}
.active-checkbox {
  padding-left: 6px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/users/Form.vue